import { HeadlineLevelContext } from "@/core/context/HeadlineLevelContext.tsx";
import { FC, PropsWithChildren, useContext } from "react";

interface ISectionProps extends PropsWithChildren {
    /**
     * Optional class string
     */
    className?: string;
}

const Section: FC<ISectionProps> = ({ children, className }) => {
    const level = useContext(HeadlineLevelContext);
    return (
        <section className={className}>
            <HeadlineLevelContext.Provider value={level + 1}>{children}</HeadlineLevelContext.Provider>
        </section>
    );
};
export default Section;
